/**
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; under version 2
 * of the License (non-upgradable).
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 *
 * Copyright (c) 2020-23 (original work) Open Assessment Technologies SA ;
 */

/**
 * Safe object properties extractor:
 *    const object = { 'a': { 'b': { 'c': 3 } } };
 *    get(object, 'a.b.c') => 3
 *    get(object, 'a.b.d', 'default') => 'default'
 *
 * @param {Object} obj object - The object to query.
 * @param {string} path - The path of the property to get.
 * @param {*} [defaultValue] - The value returned for undefined resolved values.
 * @returns {*}
 */
export const get = (obj, path, defaultValue) => {
    const properties = path.split('.');
    let currentObj = obj;

    for (let i = 0; i < properties.length && currentObj; i++) {
        const property = properties[i];
        currentObj = currentObj[property];
    }

    return currentObj === void 0 ? defaultValue : currentObj;
};
